import React from 'react';
import { intercomDirectoryRoute as route } from 'routes/constants';

const RouteComponent = React.lazy(() => import('./IntercomDirectoryPage'));

export default {
  RouteComponent,
  path: route,
};
